import {Component, ElementRef, HostListener, OnDestroy, OnInit, signal, viewChild} from "@angular/core";
import {MatIcon} from "@angular/material/icon";
import {MatIconButton} from "@angular/material/button";
import {explicitEffect} from "ngxtension/explicit-effect";
import {MatDivider} from "@angular/material/divider";

@Component({
	selector: "sim-chevron-overflow",
	templateUrl: "./chevron-overflow.component.html",
	styleUrl: "./chevron-overflow.component.scss",
	imports: [MatIcon, MatIconButton, MatDivider],
})
export class ChevronOverflowComponent implements OnInit, OnDestroy {
	// Children
	protected readonly boundStart = viewChild.required<ElementRef<HTMLDivElement>>("boundStart");
	protected readonly boundEnd = viewChild.required<ElementRef<HTMLDivElement>>("boundEnd");
	protected readonly viewport = viewChild.required<ElementRef<HTMLDivElement>>("viewport");

	// Properties
	protected readonly isOverflowing = signal<any | null>(null);
	protected readonly isStart = signal<boolean>(false);
	protected readonly isEnd = signal<boolean>(false);
	#observer: IntersectionObserver | undefined;

	// Effect
	readonly #initEffect = explicitEffect([this.viewport], () => {
		setTimeout(() => this.checkOverflow(), 500);
	});

	public ngOnInit() {
		this.#observer = new IntersectionObserver((entries) => {
			this.isStart.set(false);
			this.isEnd.set(false);
			const bound = entries.at(0);
			if (!bound?.isIntersecting) {
				return;
			}
			if (bound?.target.classList.contains("start")) {
				this.isStart.set(true);
			}
			if (bound?.target.classList.contains("end")) {
				this.isEnd.set(true);
			}
		});
		this.#observer.observe(this.boundEnd().nativeElement);
		this.#observer.observe(this.boundStart().nativeElement);
	}

	public ngOnDestroy(): void {
		this.#observer?.disconnect();
	}

	protected doScrollViewport(direction: "start" | "end") {
		const element = this.viewport().nativeElement;
		const scrollAmount = 200;
		if (direction === "start") {
			element.scrollTo({
				left: element.scrollLeft - scrollAmount,
				behavior: "smooth",
			});
		} else {
			element.scrollTo({
				left: element.scrollLeft + scrollAmount,
				behavior: "smooth",
			});
		}
	}

	@HostListener("window:resize", ["$event"])
	public checkOverflow(): void {
		if (this.viewport()) {
			const element = this.viewport().nativeElement;
			const buffer = 20; // overflow detection works better with a small buffer
			this.isOverflowing.set(element.scrollWidth > element.clientWidth + buffer);
		}
	}
}
